<template>
  <div class="home">
    <img class="home__particles" src="@/assets/practices/home/background.png" alt="particles" />
    <div class="home__navigation">
      <div class="home__navigation--container">
        <a href="/">
          <img class="home__logo" src="@/assets/practices/home/logo_hmp.svg" alt="logo" />
        </a>
        <ul class="home__links">
          <li class="home__link">
            <a href="https://myhmp.org/" target="_blank" rel="noreferrer">Home & Media Products</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="home__hero">
      <h1 class="hero__title">Have Fun & Learn!</h1>
      <img class="hero__image" src="@/assets/practices/home/hero.svg" alt="hero" />
      <h3 class="hero__subtitle">Try some of our mini games!</h3>
    </div>
    <div class="home__body">
      <div class="home__card">
        <!-- <div class="home__body--container"> -->
        <div class="home__information">
          <h1 class="information__title">{{ information.title }}</h1>
          <img
            v-if="information.image !== ''"
            class="information__image"
            :src="require(`@/assets/practices/home/${information.image}.png`)"
            alt="game"
          />
          <img v-else src="#" alt="image" />
          <h4 class="information__subject">Subject: {{ information.subject }}</h4>
          <p class="information__description">{{ information.description }}</p>
          <router-link :to="{ name: information.link }">
            <img class="information__play" src="@/assets/practices/home/button_play.svg" alt="play" />
          </router-link>
        </div>
        <!-- </div> -->
      </div>
      <div class="home__card">
        <div class="home__games">
          <h1>More Games</h1>
          <button
            v-for="game in games"
            :key="game.index"
            class="home__button"
            @click="setInformation(game.title, game.subject, game.description, game.link, game.image)"
          >
            {{ game.title }}
          </button>
        </div>
      </div>
    </div>
    <div class="home__footer">© 2019, Home & Media Products, LLC. All Rights Reserved.</div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data: () => ({
    information: {
      description: '',
      image: '',
      link: '',
      subject: '',
      title: '',
    },
    games: {
      easterEgg: {
        description: 'Learn about even and odd numbers! Choose the egg with the correct number.',
        image: 'preview_easter_egg',
        // link: '/easter-egg',
        link: 'EasterEgg',
        subject: 'Math',
        title: 'Easter Egg',
      },
      expandedForm: {
        description:
          "Learn about the expanded form of numbers! Drag one of the four eggs to the dragon's nest. If the egg you selected was correct, it will turn golden, if not it will turn to ashes.",
        image: 'preview_expanded_form',
        // link: '/expanded-form',
        link: 'ExpandedForm',
        subject: 'Math',
        title: 'Expanded Form',
      },
      fishyProblems: {
        description:
          'Calculate time! Read the question and select one of the three fishes with the answer in its bubble.',
        image: 'preview_fishy_problems',
        // link: '/fishy-problems',
        link: 'FishyProblems',
        subject: 'Math',
        title: 'Fishy Problems',
      },
      petLife: {
        description:
          'Simple math problems! Read the question and press the button with the correct answer. Also, how cute are those cats?',
        image: 'preview_pet_life',
        // link: '/pet-life',
        link: 'PetLife',
        subject: 'Math',
        title: 'Pet Life',
      },
      pumpkinClock: {
        description:
          'Learn to tell time! Look closely at the hands in the clock and select the pumpkin with the correct time. Remember, the larger clock hand tells minutes, the smaller one hours.',
        image: 'preview_pumpkin_clock',
        // link: '/pumpkin-clock',
        link: 'PumpkinClock',
        subject: 'Math',
        title: 'Pumpkin Clock',
      },
      savingMoney: {
        description:
          'An important lesson on the value of money! Learn about four different coins; how they look and what they are worth. Drag and drop the correct coins to the appropriate pig.',
        image: 'preview_saving_money',
        // link: '/saving-money',
        link: 'SavingMoney',
        subject: 'Math',
        title: 'Saving Money',
      },
      soccerGoal: {
        description:
          'Time to play soccer! Learn about the Greater Than & Less Than symbols. Choose the symbol that compares the two numbers correctly. ',
        image: 'preview_soccer_goal',
        // link: '/soccer-goal',
        link: 'SoccerGoal',
        subject: 'Math',
        title: 'Soccer Goal',
      },
    },
  }),
  mounted() {
    this.setInformation(
      this.games.easterEgg.title,
      this.games.easterEgg.subject,
      this.games.easterEgg.description,
      this.games.easterEgg.link,
      this.games.easterEgg.image,
    );
  },
  methods: {
    setInformation(title, subject, description, link, image) {
      this.information.title = title;
      this.information.subject = subject;
      this.information.description = description;
      this.information.link = link;
      this.information.image = image;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/practices/home/styles/main.scss';

$container: 1400px;

.home {
  // background: #4d4fca;
  background: #d3f6be;
  background: radial-gradient(circle at bottom right, #d3f6be 0%, #0f8bad 50%, #9661f0 100%);
  flex-direction: column;
  font-family: 'Roboto', sans-serif;
  height: 100%;
  padding: 2rem;
  @include flex(flex-start, center);

  * {
    z-index: 1;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  &__button {
    background: #12d5c1;
    // background: linear-gradient(180deg, #9661f0 0%, #4945e2 100%);
    border: none;
    border-radius: 8px;
    box-shadow: 0.05rem 0.05rem 0.25rem #555555cc;
    color: white;
    cursor: pointer;
    font-size: 1.5rem;
    font-weight: 700;
    height: 80px;
    margin: 0.25rem;
    outline: none;
    width: 400px;

    &:nth-child(odd) {
      background-color: #3396d6;
    }

    &:nth-child(even) {
      background-color: #12d5c1;
    }

    &:hover {
      transform: scale(1.05);
    }

    &:active {
      transform: scale(0.95);
    }

    &--information {
      background: #e24545;
      // background: linear-gradient(180deg, #f06161 0%, #e24545 100%);
      margin: 0;
    }
  }

  &__card {
    background-color: #f5f7fa;
    border-radius: 20px;
    box-shadow: 0.25rem 0.25rem 0.5rem #555555cc;
    box-sizing: border-box;
    flex-wrap: wrap;
    margin: 1rem;
    padding: 0.5rem;
    @include flex(center, flex-start);

    h1 {
      color: #9661f0;
    }
  }

  &__body {
    flex-wrap: wrap;
    @include flex(center, flex-start);
  }

  &__footer {
    color: white;
    margin-top: 2rem;
  }

  &__games {
    flex-wrap: wrap;
    margin: 2rem;
    width: 400px;
    @include flex(center, center);
  }

  &__hero {
    color: white;
    margin: 2rem;
    max-width: 700px;
    text-align: center;

    &--container {
      background-color: red;
      width: $container;
    }
  }

  &__information {
    margin: 2rem;
    text-align: center;
    max-width: 800px;
  }

  &__link {
    margin-left: 2rem;
  }

  &__links {
    list-style: none;
    text-align: center;
    @include flex(center, center);
  }

  &__logo {
    height: 100%;
  }

  &__particles {
    object-fit: fill;
    opacity: 0.15;
    position: fixed;
    min-height: 100%;
    min-width: 100%;
    top: 0;
    z-index: 0;
  }

  &__navigation {
    color: white;
    height: 5rem;
    font-weight: 500;
    width: 100%;
    @include flex(center, center);

    &--container {
      width: $container;
      @include flex(space-between, center);
    }
  }
}

.hero {
  &__image {
    width: 80%;
    padding: 1rem 0;
  }

  &__title {
    font-size: 3rem;
    // text-transform: uppercase;
  }

  &__subtitle {
    font-size: 2rem;
  }
}

.information {
  &__image {
    border-radius: 8px;
    object-fit: contain;
    width: 100%;
  }

  &__play {
    height: 100px;

    &:hover {
      transform: scale(1.05);
    }

    &:active {
      transform: scale(0.95);
    }
  }

  &__description,
  &__subject {
    font-size: 1.1em;
    padding: 0.5rem 0;
  }
}
</style>
